<div
  class="mb-4 flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-6 filters-shadow"
  (click)="onContainerClick($event)">
  <div class="grid grid-cols-3 gap-6 pt-4">
    <!-- <div class="grid grid-cols-3 gap-6 border-b border-[#E5E7EB] pb-6"> -->
    <app-filter-input
      [label]="isArabic() ? 'رقم الطلب' : 'Order ID'"
      [placeholder]="isArabic() ? 'ابحث برقم الطلب...' : 'Search by order ID'"
      type="number"
      [(value)]="orderId"></app-filter-input>

    <app-filter-product-search
      [label]="isArabic() ? 'مالك الصيدلية' : 'Pharmacy Owner'"
      [placeholder]="isArabic() ? 'ابحث باسم المالك...' : 'Search by pharmacy owner'"
      [loading]="ownerLoading()"
      [error]="ownerError()"
      [results]="ownerResults()"
      [(searchTerm)]="ownerSearchTerm"
      [(showDropdown)]="showOwnerDropdown"
      (searchChange)="onOwnerSearchChange($event)"
      (selectItem)="onOwnerSelect($event)"></app-filter-product-search>

    <app-filter-select-component
      [label]="isArabic() ? 'الحالة' : 'Status'"
      [defaultOption]="isArabic() ? 'الكل' : 'All'"
      [options]="statusOptions()"
      [(value)]="selectedStatusId"></app-filter-select-component>

    <div class="flex flex-col gap-1">
      <app-filter-input
        [label]="isArabic() ? 'قيمة الفاتورة (من)' : 'Invoice Amount (Min)'"
        [placeholder]="isArabic() ? 'الحد الأدنى...' : 'Min amount...'"
        type="number"
        [(value)]="invoiceAmountFrom"></app-filter-input>
    </div>

    <div class="flex flex-col gap-1">
      <app-filter-input
        [label]="isArabic() ? 'قيمة الفاتورة (إلى)' : 'Invoice Amount (Max)'"
        [placeholder]="isArabic() ? 'الحد الأقصى...' : 'Max amount...'"
        type="number"
        [(value)]="invoiceAmountTo"></app-filter-input>
      @if (invoiceAmountInvalid()) {
        <p class="text-[12px] text-red-500">
          {{ invoiceAmountErrorMessage() }}
        </p>
      }
    </div>

    <div></div>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (من)' : 'Creation Date From'"
      [value]="createdOnFrom()"
      (valueChange)="createdOnFrom.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء (إلى)' : 'Creation Date To'"
      [value]="createdOnTo()"
      (valueChange)="createdOnTo.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>

    <div></div>

    <app-filter-date-component
      [label]="isArabic() ? 'آخر تعديل (من)' : 'Last Modified From'"
      [value]="lastModifiedOnFrom()"
      (valueChange)="lastModifiedOnFrom.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'آخر تعديل (إلى)' : 'Last Modified To'"
      [value]="lastModifiedOnTo()"
      (valueChange)="lastModifiedOnTo.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>

    <div></div>
    <div></div>
  </div>
  <div class="border-border mt-4 flex justify-between border-t pt-4 pb-4">
    <app-filter-sorting-component
      [orderBy]="filters().orderBy!"
      (orderByChange)="filters().orderBy = $event"
      [orderDir]="filters().orderDir!"
      [sortOptions]="sortOptions()"
      (toggleOrder)="onToggleSortOrder()"></app-filter-sorting-component>

    <div class="flex items-end justify-end gap-3">
      <button
        (click)="onResetFilters()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApplyFilters()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
        <span i18n="@@adminProductsApplyButton">Apply</span>
      </button>
    </div>
  </div>
</div>
